import * as React from "react";
import { ReactHelper } from "../../../../utils";

export type ComposeStep = "authorship" | "details" | "uploads" | "review";

interface OwnProps {
    abstractGuid?: string;
    accessDetails: boolean;
    accessUploads: boolean;
    currentStep: ComposeStep;
    eventId: number;
    hasDetails: boolean;
    hasUploads: boolean;
    onClick: (step: string) => void;
}

export const ProgressSteps: React.SFC<OwnProps> = (props) => {

    const steps: JSX.Element[] = [];
    let number = 1;
    steps.push(<ProgressStepLink
        key={number}
        currentStep={props.currentStep}
        eventId={props.eventId}
        guid={props.abstractGuid}
        hasAccess={props.accessDetails}
        name="Authorship"
        number={number}
        step="authorship"
        onClick={(step) => props.onClick(step)}
    />);

    number++;

    if (props.hasDetails) {
        steps.push(<ProgressStepLink
            key={number}
            currentStep={props.currentStep}
            eventId={props.eventId}
            guid={props.abstractGuid}
            hasAccess={props.accessDetails}
            name="Details"
            number={number}
            step="details"
            onClick={(step) => props.onClick(step)}
        />);
        number++;
    }

    if (props.hasUploads) {
        steps.push(<ProgressStepLink
            key={number}
            currentStep={props.currentStep}
            eventId={props.eventId}
            guid={props.abstractGuid}
            hasAccess={props.accessUploads}
            name="Uploads"
            number={number}
            step="uploads"
            onClick={(step) => props.onClick(step)}
        />);
        number++;
    }

    steps.push(<ProgressStepLink
        key={number}
        currentStep={props.currentStep}
        eventId={props.eventId}
        guid={props.abstractGuid}
        hasAccess={props.accessDetails}
        name="Review"
        number={number}
        step="review"
        onClick={(step) => props.onClick(step)}
    />);

    return <ol className="progress-nav">
        {steps}
    </ol>;
};

interface ProgressStepLinkProps {
    currentStep: ComposeStep;
    eventId: number;
    guid?: string;
    hasAccess: boolean;
    name: string;
    number: number;
    step: ComposeStep;
    onClick: (step: string) => void;
}

const ProgressStepLink: React.SFC<ProgressStepLinkProps> = (props) => {
    return props.currentStep === props.step || !props.guid || !props.hasAccess
        ? <li className={props.currentStep === props.step ? "current" : ""}>
            <strong className="step">{props.number}</strong>{" "}
            <span className="title">{props.name}</span>
        </li>
        : <li>
            <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); props.onClick(props.step); }}>
                <strong className="step">{props.number}</strong>{" "}
                <span className="title">{props.name}</span>
            </a>
        </li>;
};



// WEBPACK FOOTER //
// ./src/containers/abstracts/composer/components/ProgressSteps.tsx